export default __webpack_public_path__ + "static/media/info.0df96810.svg";